<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import IconPlus from '@/components/icons/Plus';
import IconCog from '@/components/icons/Cog';
import PluralText from '@/components/PluralText';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import service from './service';

export default {
  pageTitle: 'Администраторы',
  async prefetchData () {
    if (!this.hasReadPermission) {
      return;
    }

    this.isFetching = true;

    this.list = await service.getList();

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      list: [],
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.ADMIN_READ);
    },
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.ADMIN_WRITE);
    },
  },
  methods: {
    handleChildrenViewClose () {
      this.$_setTitle();
    },
    handleDataUpdate () {
      service
        .getList()
        .then(data => {
          this.list = data;
        });
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return <ErrorAccessDenied />;
    }

    const { isFetching, list } = this;

    return (
      <div>
        <u-title class="page-header">
          <span>
            Список администраторов
          </span>
          {this.hasWritePermission && (
            <router-link
              class="u-btn u-btn_outline u-btn_square u-btn_primary"
              to="/admins/create"
            >
              <IconPlus />
            </router-link>
          )}
        </u-title>

        {isFetching ? (
          <u-spinner />
        ) : (
          <u-table>
            {list.map(admin => (
              <u-tr key={admin.id}>
                <u-td width="1">
                  <router-link to={`/admins/${admin.id}`}>
                    {admin.username}
                  </router-link>
                </u-td>
                <u-td width="1">
                  {Boolean(admin.isBot) && (
                    <IconCog />
                  )}
                </u-td>
                <u-td align="right">
                  {Array.isArray(admin.permissions)
                    ? admin.permissions.length
                    : 0}
                  <PluralText
                    value={Array.isArray(admin.permissions)
                      ? admin.permissions.length
                      : 0}
                    single=" полномочие"
                    few=" полномочия"
                    many=" полномочий"
                  />
                </u-td>
              </u-tr>
            ))}
          </u-table>
        )}

        <router-view
          onClose={this.handleChildrenViewClose}
          onDataupdate={this.handleDataUpdate}
        />
      </div>
    );
  },
};
</script>
